import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { X, Check, ArrowDown } from 'lucide-react';
export function ComparisonSection() {
  return <Section background="cream" className="relative" data-id="element-22">
      <div className="text-center mb-8 md:mb-12" data-id="element-23">
        <h2 className="text-2xl md:text-4xl font-bold text-[#2D6A4F] mb-3" data-id="element-24">
          3 caminos (solo uno te quita la duda cada día)
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-8 items-start" data-id="element-25">
        {/* Option 1 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100 opacity-80 hover:opacity-100 transition-opacity" data-id="element-26">
          <h3 className="text-lg md:text-xl font-bold text-gray-500 mb-3" data-id="element-27">
            Opción 1: <br data-id="element-28" />
            Improvisar / "ya veré"
          </h3>
          <ul className="space-y-3 mb-4 text-sm text-gray-600" data-id="element-29">
            <li className="flex items-start" data-id="element-30">
              <X className="w-4 h-4 text-red-400 mr-2 mt-1 flex-shrink-0" data-id="element-31" />
              Buscas recetas sueltas, dudas con ingredientes
            </li>
            <li className="flex items-start" data-id="element-32">
              <X className="w-4 h-4 text-red-400 mr-2 mt-1 flex-shrink-0" data-id="element-33" />
              Comes con miedo o resignación
            </li>
          </ul>
          <div className="pt-3 border-t border-gray-100" data-id="element-34">
            <p className="font-semibold text-gray-500" data-id="element-35">Resultado típico:</p>
            <p className="text-red-500 font-medium" data-id="element-36">
              Ansiedad + abandono + picos por falta de plan
            </p>
          </div>
        </motion.div>

        {/* Option 2 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100 opacity-80 hover:opacity-100 transition-opacity" data-id="element-37">
          <h3 className="text-lg md:text-xl font-bold text-gray-500 mb-3" data-id="element-38">
            Opción 2: <br data-id="element-39" />
            Dietas estrictas
          </h3>
          <ul className="space-y-3 mb-4 text-sm text-gray-600" data-id="element-40">
            <li className="flex items-start" data-id="element-41">
              <X className="w-4 h-4 text-red-400 mr-2 mt-1 flex-shrink-0" data-id="element-42" />
              Aguantas unos días, luego hambre
            </li>
            <li className="flex items-start" data-id="element-43">
              <X className="w-4 h-4 text-red-400 mr-2 mt-1 flex-shrink-0" data-id="element-44" />
              Antojos y frustración social
            </li>
          </ul>
          <div className="pt-3 border-t border-gray-100" data-id="element-45">
            <p className="font-semibold text-gray-500" data-id="element-46">Resultado típico:</p>
            <p className="text-red-500 font-medium" data-id="element-47">
              Efecto rebote y sensación de "no puedo"
            </p>
          </div>
        </motion.div>

        {/* Option 3 - Winner */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="bg-white p-6 md:p-8 rounded-2xl shadow-xl border-2 border-[#BC6C25] relative transform md:-translate-y-4 z-10" data-id="element-48">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#BC6C25] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-49">
            Recomendado
          </div>
          <h3 className="text-xl md:text-2xl font-bold text-[#2D6A4F] mb-3" data-id="element-50">
            Opción 3: <br data-id="element-51" />
            Guía + Método Plato Estable
          </h3>
          <ul className="space-y-3 mb-6 text-gray-700" data-id="element-52">
            <li className="flex items-start" data-id="element-53">
              <Check className="w-5 h-5 text-[#52B788] mr-2 mt-0.5 flex-shrink-0" data-id="element-54" />
              Porciones claras
            </li>
            <li className="flex items-start" data-id="element-55">
              <Check className="w-5 h-5 text-[#52B788] mr-2 mt-0.5 flex-shrink-0" data-id="element-56" />
              Prioridades del plato
            </li>
            <li className="flex items-start" data-id="element-57">
              <Check className="w-5 h-5 text-[#52B788] mr-2 mt-0.5 flex-shrink-0" data-id="element-58" />
              Recetas repetibles y ricas
            </li>
          </ul>
          <div className="pt-4 border-t border-gray-100 mb-4" data-id="element-59">
            <p className="font-semibold text-gray-800" data-id="element-60">Resultado típico:</p>
            <p className="text-[#2D6A4F] font-bold text-lg" data-id="element-61">
              Más control, más calma, más consistencia
            </p>
          </div>
          <Button variant="primary" className="w-full" onClick={() => document.getElementById('compra')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-62">
            Sí, quiero el Método Plato Estable
          </Button>
        </motion.div>
      </div>

      <div className="mt-10 md:mt-16 max-w-3xl mx-auto text-center" data-id="element-63">
        <div className="flex justify-center mb-3" data-id="element-64">
          <ArrowDown className="w-8 h-8 text-[#BC6C25] animate-bounce" data-id="element-65" />
        </div>
        <p className="text-lg md:text-xl text-gray-700 font-medium" data-id="element-66">
          El cambio llega cuando dejas de perseguir "la receta perfecta" y usas
          un sistema simple:
          <br data-id="element-67" />
          <span className="text-[#2D6A4F] font-bold text-xl md:text-2xl mt-2 block" data-id="element-68">
            Método Plato Estable → elegir mejor + cocinar fácil + repetir sin
            pensar.
          </span>
        </p>
        <p className="mt-3 text-sm text-gray-500" data-id="element-69">
          Ideal si estás recién diagnosticado/a, en prediabetes o cocinas para
          alguien con diabetes.
        </p>
      </div>
    </Section>;
}